import { createContext, useState, useEffect } from "react";
import stocks from "../constants/stocks";
import { fetchBulkPrices, fetchDolarCCL } from "../api/stockApi";

const PreciosContext = createContext();

const PreciosProvider = ({ children }) => {
  const [localStocks, setLocalStocks] = useState(stocks);
  const [dolarCCL, setDolarCCL] = useState(null);

  useEffect(() => {
    const initPrices = async () => {
      // 1. Fetch Dolar CCL
      const cclValue = await fetchDolarCCL();
      setDolarCCL(cclValue);

      // 2. Fetch prices for ALL stocks in batches for efficiency
      const allTickers = stocks.map(s => s.ticker);
      await actualizarPreciosBulk(allTickers);
    };

    initPrices();

    // Refresh every 5 minutes
    const interval = setInterval(initPrices, 300000);
    return () => clearInterval(interval);
  }, []);

  const actualizarPreciosBulk = async (tickers) => {
    console.log(`Actualizando ${tickers.length} acciones...`);

    // Batch size of 50 for efficiency without hitting timeout limits
    const BATCH_SIZE = 50;

    for (let i = 0; i < tickers.length; i += BATCH_SIZE) {
      const batch = tickers.slice(i, i + BATCH_SIZE);
      try {
        const pricesData = await fetchBulkPrices(batch);
        if (pricesData) {
          setLocalStocks((prevStocks) => {
            const newStocks = [...prevStocks];
            Object.entries(pricesData).forEach(([ticker, data]) => {
              const index = newStocks.findIndex(s => s.ticker === ticker);
              if (index !== -1) {
                newStocks[index] = {
                  ...newStocks[index],
                  price: data.actual_price,
                  actual_price: data.actual_price,
                  previous_close: data.previous_close
                };
              }
            });
            return newStocks;
          });
        }
      } catch (error) {
        console.error(`Error en lote ${i}:`, error);
      }
    }
  };

  const actualizarPrecios = async (tickers) => {
    await actualizarPreciosBulk(tickers);
  };
  return (
    <PreciosContext.Provider
      value={{
        stocks: localStocks,
        setStocks: setLocalStocks,
        dolarCCL: dolarCCL,
      }}
    >
      {children}
    </PreciosContext.Provider>
  );
};

export { PreciosProvider, PreciosContext };
